export enum EventCategories {
    Coding = 'Coding',
    CodingAccruals = 'CodingAccruals',
    CopyCoding = 'CopyCoding',
    DocumentHeaders = 'DocumentHeaders',
    DocumentList = 'DocumentList',
    Link = 'Link',
    LinkDocuments = 'LinkDocuments',
    Matching = 'Matching',
    News = 'News',
    OcrTraining = 'OcrTraining',
    Sam = 'Sam',
    SamLinePredictor = 'SAM.LinePredictor',
    SamCodingLines = 'SAM.CodingLines',
    Search = 'Search',
    SuperVisor = 'SuperVisor',
    TemplateSharing = 'TemplateSharing',
}

export enum EventActions {
    AddNever = 'AddNever',
    Always = 'Always',
    Applied = 'Applied',
    Clicked = 'Clicked',
    Copied = 'Copied',
    Declined = 'Declined',
    DeleteNever = 'DeleteNever',
    Disabled = 'Disabled',
    Enabled = 'Enabled',
    LineCreated = 'LineCreated',
    LineDeleted = 'LineDeleted',
    LinkClicked = 'LinkClicked',
    Linked = 'Linked',
    ListOpenend = 'ListOpenend',
    ModalClosed = 'ModalClosed',
    ModalOpened = 'ModalOpened',
    Preview = 'Preview',
    RouteClicked = 'RouteClicked',
    Saved = 'Saved',
    Shown = 'Shown',
    Submit = 'Submit',
    Updated = 'Updated',
}

export enum EventCustomDimensions {
    AdministrationCode = 10,
    EnvironmentCode = 11,
    Creditor = 12,
    SourceDocId = 13,
}

export enum UserCustomDimensions {
    TenantId = 1,
    TenantName = 2,
    Erp = 3,
    UserType = 4,
    HublApiVersion = 5,
    HublReactVersion = 6,
    DocbaseVersion = 7,
    SSOEmailAddress = 14,
}
